import { FairfashionModule, RequestAgentDTO } from '../../sdk/user/user.types'

import { routes, UserRole } from './routes'

export const userHasPermission = (
  userType: string,
  permissions: UserRole[],
) => {
  if (permissions.includes('all')) return true

  if (permissions.includes(userType as UserRole)) return true

  if (
    permissions.includes('providers') &&
    userType !== 'fashion_company' &&
    userType !== 'blockforce'
  ) {
    return true
  }
}

export const userEcosystemHasModule = (
  module: FairfashionModule,
  contractedModules: FairfashionModule[],
) => {
  if (contractedModules.includes(module)) return true

  return false
}

export const getFilteredRoutes = (user?: RequestAgentDTO | null) => {
  return routes
    .filter((route) =>
      userHasPermission(user?.company?.segment ?? '', route.permissions),
    )
    .filter((route) => {
      if (!route.module) return true

      return userEcosystemHasModule(route.module, user?.contractedModules ?? [])
    })
}
